/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUsersOptions, GetUsersStatus200, GetUsersStatus500 } from '../types/GetUsers'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getUsers } from '../clients/getUsers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersQueryKey = ({ query }: Omit<GetUsersOptions, 'headers'> = {}) =>
  [{ url: '/v1/user' }, ...(query ? [query] : [])] as const

type GetUsersQueryKey = ReturnType<typeof getUsersQueryKey>

export function getUsersQueryOptions(
  { query }: GetUsersOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getUsersQueryKey({ query })
  return queryOptions<
    GetUsersStatus200,
    ResponseErrorConfig<GetUsersStatus500>,
    GetUsersStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getUsers({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get all users (admin only)
 * {@link /v1/user}
 */
export function useGetUsers<
  TData = GetUsersStatus200,
  TQueryData = GetUsersStatus200,
  TQueryKey extends QueryKey = GetUsersQueryKey,
>(
  { query }: { query?: GetUsersOptions['query'] | (() => GetUsersOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUsersStatus200,
        ResponseErrorConfig<GetUsersStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getUsersQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getUsersQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUsersStatus500>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
